import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import {
  ChatRepositoryPort,
  DeliveryTarget,
  PaymentRetryPayload,
  PaymentRetryResponse,
  ReportContext,
  ReportSubmission
} from '@domain/ports';
import { ChatDetail, ChatSummary, CreateChatPayload } from '@domain/models';
import { httpUrl } from '@shared/runtime-config';

@Injectable({ providedIn: 'root' })
export class HttpChatRepository extends ChatRepositoryPort {
  private readonly http = inject(HttpClient);
  private readonly base = `${httpUrl('whatsapp')}/api/v1/chats`;

  list(): Observable<ChatSummary[]> {
    return this.http.get<ChatSummary[]>(this.base);
  }

  getById(chatId: string | number): Observable<ChatDetail | null> {
    return this.http.get<ChatDetail>(`${this.base}/${chatId}`).pipe(
      catchError((err: HttpErrorResponse) =>
        err.status === 404 ? of(null) : throwError(() => err))
    );
  }

  create(payload: CreateChatPayload): Observable<ChatDetail> {
    return this.http.post<ChatDetail>(this.base, payload);
  }

  getReportContext(chatId: string | number, messageId: string): Observable<ReportContext> {
    return this.http.get<ReportContext>(`${this.base}/${chatId}/messages/${messageId}/report-context`);
  }

  submitReport(chatId: string | number, messageId: string,
    agentCode: string, deliveryTarget: DeliveryTarget): Observable<ReportSubmission> {
    return this.http.post<ReportSubmission>(
      `${this.base}/${chatId}/messages/${messageId}/report-submission`,
      {agentCode, deliveryTarget}
    );
  }

  submitPaymentRetry(chatId: string | number, botMessageId: string,
    payload: PaymentRetryPayload): Observable<PaymentRetryResponse> {
    return this.http.post<PaymentRetryResponse>(
      `${this.base}/${chatId}/messages/${botMessageId}/payment-retry`,
      payload,
      {headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })}
    );
  }
}
